import React from "react";
import PageHeroSection from "../../components/ui/PageSections/PageHeroSection";
import EmpowerServicesSection from "../../components/ui/PageSections/EmpowerServicesSection";
import Section from "../../components/ui/Section";
import SecondaryInputTable from "../../components/ui/InputTables/SecondaryInputTable";
import iconIpTransit from "../../images/icons/icon-ip-transit.svg";
import iconIptransitStat1 from "../../images/icons/icon-iptransit-stat1.svg";
import iconIptransitStat3 from "../../images/icons/icon-iptransit-stat3.svg";
import iconIptransitStat4 from "../../images/icons/icon-iptransit-stat4.svg";
import iconIptransitStat5 from "../../images/icons/icon-iptransit-stat5.svg";
import vectorIptransitMainGraph from "../../images/ip-transit-main-graph.svg";

import ServiceKeyFeaturesSection from "../../components/ui/PageSections/ServiceKeyFeaturesSection";
import { navigate } from "gatsby";
import PresenceBanner from "../../components/ui/PageSections/PresenceBanner";
import ContactUsBanner from "../../components/ui/PageSections/ContactUsBanner";

const IpTransitPageTemplate = ({ pageContext, translations }) => {
	return (
		<div id="IpTransitInputSection">
			<PageHeroSection
				heroIcon={iconIpTransit}
				heroIconAltText="White rombus rack icon"
				intro={translations["IpTransitIntro"]}
				heroTitle={
					translations["IpTransitMainTitle"] ? translations["IpTransitMainTitle"] : pageContext.h1Title
				}
				subtitle={translations["IpTransitSubtitle"] ? translations["IpTransitSubtitle"] : pageContext.h2Title}
			/>
			<SecondaryInputTable
				serviceType="iptransit"
				defaultIataCode={pageContext.iataCode}
				translations={translations}
				pageContext={pageContext}
				featureList={["SLA 99.98%", "Record Time Provision", "Low Latency"]}
			/>
			<Section color="white" skewed="bottom">
				<div className="w-full flex flex-col xl:flex-row">
					<div className="w-full xl:w-[49%] mb-6 xl:mb-0">
						<img
							className="w-4/5 m-auto"
							alt="Ip transit cloud infraestructure"
							src={vectorIptransitMainGraph}
						/>
					</div>
					<div className="w-full xl:w-[49%] m-auto">
						<div className="bg-gray-100 p-4 xl:p-8 rounded-lg max-w-[600px] h-fit mt-6 xl:mt-0 md:mx-auto">
							<ServiceStats
								stats={[
									{
										icon: iconIptransitStat1,
										title: translations["IpTransitStatOneTitle"],
										text: translations["IpTransitStatOneText"],
									},
									{
										icon: iconIptransitStat3,
										title: translations["IpTransitStatThreeTitle"],
										text: translations["IpTransitStatThreeText"],
									},
									{
										icon: iconIptransitStat4,
										title: translations["IpTransitStatFourTitle"],
										text: translations["IpTransitStatFourText"],
									},
									{
										icon: iconIptransitStat5,
										title: translations["IpTransitStatFiveTitle"],
										text: translations["IpTransitStatFiveText"],
									},
								]}
							/>
						</div>
					</div>
				</div>
				<ServiceKeyFeaturesSection
					textColor="white"
					subtitle={translations["IpTransitKeyCharTitle"]}
					characteristicsList={[
						{
							title: translations["IpTransitKeyCharOneTitle"],
							text: translations["IpTransitKeyCharOneText"],
						},
						{
							title: translations["IpTransitKeyCharTwoTitle"],
							text: translations["IpTransitKeyCharTwoText"],
						},
						{
							title: translations["IpTransitKeyCharThreeTitle"],
							text: translations["IpTransitKeyCharThreeText"],
						},
						{
							title: translations["IpTransitKeyCharFourTitle"],
							text: translations["IpTransitKeyCharFourText"],
						},
						{
							title: translations["IpTransitKeyCharFiveTitle"],
							text: translations["IpTransitKeyCharFiveText"],
						},
					]}
					buttonText={translations["IpTransitKeyCharButtonText"]}
					onClickHandler={() => {
						navigate("#IpTransitInputSection");
					}}
				/>
			</Section>
			<Section color="transparent">
				<EmpowerServicesSection translations={translations} />
			</Section>
			<Section color="white">
				<PresenceBanner translations={translations} />
			</Section>
			<Section color="transparent">
				<ContactUsBanner
					title={translations["IpTransitContactUsBannerTitle"]}
					subtitle={translations["IpTransitContactUsBannerText"]}
					contactText={translations["contact"]}
				/>
			</Section>
		</div>
	);
};

export default IpTransitPageTemplate;

const ServiceStats = ({ stats = [] }) => (
	<section className="w-full text-ipxon-black grid grid-cols-2 gap-8">
		{stats.map((stat) => (
			<ServiceStat title={stat.title} text={stat.text} icon={stat.icon} key={stat.title} />
		))}
	</section>
);

const ServiceStat = ({ title, text, icon }) => (
	<div className="flex flex-col gap-2 text-sm text-ipxon-black">
		<img src={icon} alt="Stats Icon" className="h-[30px] md:h-[30px] w-[30px]" />
		<div className="flex flex-col">
			<h5 className="font-bold text-sm">{title}</h5>
			<p className="text-sm">{text}</p>
		</div>
	</div>
);
